import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      margin: '0px auto',
      maxHeight: '659px',
      width: "100%"
    },
    headerModal: {
      padding: '16px 24px',
      justifyContent: 'space-between',
      borderRadius: '0px 0px 8px 8px',
      height: '16%',
      display: 'grid',
      alignItems: 'center',
      gridColumnGap: 20,
      gridTemplateColumns: '5fr 2fr 3fr',
      position: 'relative',
      zIndex: 2,
      width: "100%"
    },
    customDot: {
      marginTop: 0,
      '&>div': {
        marginRight: 6,
        '&>div': {
          width: 12,
          height: 12,
        }
      }
    },
    titleModal: {
      color: theme.custom.colors.primary,
      '& p:first-child': {
        font: 'normal normal 700 18px/32px Public-Sans',
        overflow: 'hidden',
        maxWidth: 200,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      '& p:nth-child(2)': {
        font: theme.custom.font.montserrat16,
      }
    },
    dFlexRight: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 15
    },
    bodyModalList:{
      // padding: '24px 47px',
      // maxHeight: '84%',
      // overflowY: 'scroll'
    },
    btnAddRecipeBody: {
      '& button': {
        height: 32,
        background: theme.custom.colors.primary,
        fontWeight: 'bold',
        color: theme.custom.colors.white,
        fontSize: theme.custom.fontSize.size16,
        fontFamily: theme.custom.fontFamily.bold,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        // '&:hover': {
        //   background: theme.custom.colors.primary,
        // },
      },
    },
    footerModal: {
      height: '12%',
      padding: '16px 24px',
      display: 'flex',
      boxShadow: '1px 1px 6px rgba(56, 25, 81, 0.25)',
      justifyContent: 'flex-end',
      alignItems: 'center',
      font: 'normal normal 500 16px/24px Public-Sans',
      '& div:first-child': {
        marginRight: 24,
        cursor: 'pointer',
      }
    },
    backButton: {
      color: "black",
      textAlign: "center",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: 900,
      lineHeight: "normal",
      padding: "7px 16px",
      backgroundColor: "#D2D2D2",
      borderRadius: "100px",
      border: "none",
      cursor: "pointer",
    },

    cancelButton: {
      color: "black",
      textAlign: "center",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: 900,
      lineHeight: "normal",
      padding: "7px 16px",
      backgroundColor: "transparent",
      borderRadius: "100px",
      border: "none",
      cursor: "pointer",
      marginRight: 10,
    },
    nextButton: {
      textAlign: "center",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: 900,
      lineHeight: "normal",
      padding: "7px 16px",
      border: "none",
      backgroundColor: "#0C85F4",
      borderRadius: "100px",
      color: "white",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginLeft: "24px",
      cursor: "pointer",
    },
    nextButtonIconContainer: {
      marginLeft: "7px",
    },
  };
});

export default useStyles;
